<template >
  <div class="body">
    <login-panel/>
  </div>

</template>

<script>

// import imageCard from "./components/imageCard";
// import noteCard from "./components/noteCard";
import formDialog from "./components/formDialog";
import addModel from "@/pages/addModel";
import Navigation from "@/pages/navigation";
import loginPanel from "@/components/loginPanel";
export default {
  name: "Test",
  components:{
    Navigation,
    formDialog,
    addModel,
    loginPanel,
  },
  data(){
    return {
    }
  },
  methods:{
    offer(totalPrice){
      console.log('总价格是：'+totalPrice);
    },
  },
  watch:{

  },
  created() {
  },
  mounted() {
  }

}
</script>

<style scoped>
.body{
  display: flex;
  justify-content: center;
  align-items: center;

  height: 100vh;
  width: 100%;
  background: linear-gradient(135deg,rgba(11, 102, 189,.5),rgba(42, 82, 152));
}

</style>
